const React = require("react");
const T = React.PropTypes;

require("./ToolTip.less"); 

const ToolTip = React.createClass({
    PropTypes: { 
        Message: T.string.isRequired
    },
    getInitialState() {
        return {
            hover : false 
        }
    },
    handleMouseIn() {
        this.setState({hover: true})
    },
    handleMouseOut() { 
        this.setState({hover: false})
    },
    render () 
    {
        const toolTipStyle = {
            display: this.state.hover ? 'inline-flex' : 'none'
        }

        return (<span>
                <span className="cs-glyph glyphicon glyphicon-question-sign" onMouseOver={this.handleMouseIn} onMouseOut={this.handleMouseOut }></span>
                <span className="cs-ToolTip" style={toolTipStyle }>{this.props.Message}</span>    
            </span>); 
    }
});

module.exports = ToolTip; 


// WEBPACK FOOTER //
// ./src/components/ToolTip/ToolTip.jsx